import { Badge, BadgeProps } from '@chakra-ui/react';
import React from 'react';

type SemanticColor = 'neutral' | 'info' | 'danger' | 'warning' | 'success' | 'ai';
type BadgeVariant = 'solid' | 'subtle' | 'outline' | 'surface';
type BadgeSize = 'xs' | 'sm' | 'md' | 'lg';

interface StatusBadgeProps extends Omit<BadgeProps, 'colorPalette' | 'variant' | 'size'> {
  /**
   * The semantic color of the badge
   * @default 'neutral'
   */
  status?: SemanticColor;
  /**
   * The variant of the badge
   * @default 'subtle'
   */
  variant?: BadgeVariant;
  /**
   * The size of the badge
   * @default 'sm'
   */
  size?: BadgeSize;
}

export const StatusBadge = ({
  status = 'neutral',
  variant = 'subtle',
  size = 'sm',
  children,
  ...rest
}: StatusBadgeProps) => (
  <Badge
    colorPalette={status}
    variant={variant}
    size={size}
    data-color-palette={status}
    data-variant={variant}
    data-size={size}
    {...rest}
  >
    {children}
  </Badge>
);

export default StatusBadge;
